import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS, QUERY_CONFIG } from "@/config";
import { usePublicClient } from "wagmi";
import type { Address } from "viem";

export function useENSName(address?: Address) {
    const publicClient = usePublicClient();

    const { data: ensName, isLoading } = useQuery<string | null>({
        queryKey: QUERY_KEYS.USER.ENS_NAME(address),
        queryFn: async () => {
            if (!address || !publicClient) return null;
            try {
                const name = await publicClient.getEnsName({ address });
                return name;
            } catch (error) {
                console.error("Error fetching ENS name:", error);
                return null;
            }
        },
        enabled: !!address && !!publicClient,
        ...QUERY_CONFIG.TOKENS,
    });

    return {
        ensName: ensName ?? null,
        isLoading,
    };
}
